import { TimecodeDisplay } from "./timecodeDisplay";
import { VideoPlayer } from "./videoPlayer";

export class TimeDisplay {
    private displayIn = new TimecodeDisplay("time-display-in");
    private displayCurrent = new TimecodeDisplay("time-display-current");
    private displayOut = new TimecodeDisplay("time-display-out");

    private jumpToInBtn = document.getElementById("time-display-in");
    private jumpToOutBtn = document.getElementById("time-display-out");
    private setTimeInBtn = document.getElementById("btn-set-time-in");
    private setTimeOutBtn = document.getElementById("btn-set-time-out");

    private element: HTMLElement;
    public constructor(private player: VideoPlayer) {
        const footer = document.getElementById("footer");
        if (!footer) throw new Error("Footer not found");
        this.element = footer;

        this.update();
        this.initButtons();
    }

    private initButtons() {
        this.jumpToInBtn?.addEventListener("click", () => {
            this.player.currentTime = this.player.timeIn;
        });
        this.jumpToOutBtn?.addEventListener("click", () => {
            this.player.currentTime = this.player.timeOut;
        });
        this.setTimeInBtn?.addEventListener("click", () => {
            this.player.setTimeIn();
        });
        this.setTimeOutBtn?.addEventListener("click", () =>
            this.player.setTimeOut()
        );
    }

    public update() {
        console.log("updateTimecodesDisplay");
        this.displayCurrent.update(this.player.currentTime);
        this.displayIn.update(this.player.timeIn);
        this.displayOut.update(this.player.timeOut);
    }

    public set hidden(enabled: boolean) {
        this.element.toggleAttribute("data-hidden", enabled);
    }
}
